<app-base-dialog sizeClass="size-28-75" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar" [multiRow]="true">
	<ng-template #topBar>
		<app-dialog-header [title]="done() ? 'Feedback verzonden' : 'Feedback geven'" [sluitbaar]="true" (sluiten)="sluiten()"></app-dialog-header>
	</ng-template>
	@if (done()) {
		<p>Bedankt voor je feedback. We nemen jouw input mee in onze evaluaties en doorontwikkeling.</p>
	} @else {
		<fieldset class="redenen">
			<legend class="vraag">Waarom ben je teruggegaan naar de oude navigatie?</legend>
			@for (optie of redenen; track optie.id) {
				<label class="reden" [class.is-gekozen]="reden() === optie">
					<input type="radio" name="reden" [value]="optie.id" [checked]="reden() === optie" (change)="reden.set(optie)" />
					<span class="radio-bolletje"></span>
					<span class="naam">{{ optie.label }}</span>
				</label>
			}
		</fieldset>
		@if (reden()) {
			<div class="control">
				<label class="label" for="navigatie-feedback-toelichting">{{ toelichtingVerplicht() ? 'Toelichting' : 'Toelichting (optioneel)' }}</label>
				<textarea id="navigatie-feedback-toelichting" [(ngModel)]="toelichting" [required]="toelichtingVerplicht()" placeholder="Waar liep je tegenaan?"></textarea>
			</div>
		}
		<p class="hint">Wil je de nieuwe navigatie weer proberen? Zet hem aan via je profielinstellingen.</p>
	}
	<ng-template #bottomBar>
		@if (done()) {
			<app-button (clickit)="sluiten()">Sluiten</app-button>
		} @else {
			<app-button buttonType="secondary" (clickit)="later()" [enabled]="!isBusySending()">Vraag me later</app-button>
			<app-button (clickit)="send()" [enabled]="kanVersturen()">Versturen</app-button>
		}
	</ng-template>
</app-base-dialog>
